import { render } from "./CustomersView.html?vue&type=template&id=6b93901d&scoped=true&external"
import script from "./CustomersView.js?vue&type=script&lang=js&external"
export * from "./CustomersView.js?vue&type=script&lang=js&external"

import "./CustomersView.css?vue&type=style&index=0&id=6b93901d&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b93901d"]])

export default __exports__